// A React component to be rendered in the top bar next to the top menu toggle button
export default () => null;
